// extracted by mini-css-extract-plugin
export var chevron = "_gv-4";
export var chevronExpanded = "_gv-5";
export var row = "_gv-0";
export var rowBody = "_gv-6";
export var rowDescription = "_gv-7";
export var rowHeader = "_gv-1";
export var rowTitle = "_gv-2";
export var rowTitleComplete = "_gv-3";